import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { Button } from '@winnin/winnin_ui.components.button'
import { Icon } from '@winnin/winnin_ui.components.icon'

import { BaseSkeleton } from 'components/BaseSkeleton'
import { useTranslate } from 'lib/tolgee'
import { translations as translationsCommon } from 'modules/dashboard/common/dashboard.i18n'
import { DashboardFolder } from 'modules/dashboard/dashboard-folder'
import { TOLGEE_GLOBALS } from 'utils'

import type { IDashboardFolderList } from './dashboard-folder-list.types'
import './dashboard-folder-list.styles.scss'

export const DashboardFolderListView = ({
  foldersList,
  isLoadingFolders,
  shouldRenderCreateFolderButton,
  shouldRenderLoadMore,
  loadMore,
  isListEmpty,
  shouldNotRender,
  handleCreateFolder,
  handleTrackClick,
}: IDashboardFolderList) => {
  const t = useTranslate()

  if (shouldNotRender) {
    return null
  }

  return (
    <div className={classNames(['DashboardFolderList', { isListEmpty }])}>
      <div className="listWrapper">
        {shouldRenderCreateFolderButton && (
          <Button className="createFolderButton" onClick={handleCreateFolder}>
            <Icon icon="add" fill="var(--color_neutral_800)" height="15px" width="15px" />
            {t(translationsCommon.createDashboardFolder)}
          </Button>
        )}
        {foldersList.map(item => {
          return (
            <Link key={item.id} to={item.link} onClick={() => handleTrackClick(item)}>
              <DashboardFolder
                dashboardCount={item.dashboardCount}
                folderName={item.folderName}
                actionOptions={item.dashboardFolderOptions}
              />
            </Link>
          )
        })}
      </div>
      {isLoadingFolders && (
        <div className="DashboardFolderListloadingWrapper">
          <BaseSkeleton width="100%" height="72px" borderRadius="12px" />
          <BaseSkeleton width="100%" height="72px" borderRadius="12px" />
          <BaseSkeleton width="100%" height="72px" borderRadius="12px" />
          <BaseSkeleton width="100%" height="72px" borderRadius="12px" />
        </div>
      )}
      {shouldRenderLoadMore && (
        <div className="loadMoreSection">
          <Button appearance="link" onClick={loadMore} disabled={isLoadingFolders}>
            {t(TOLGEE_GLOBALS.loadMore)}
          </Button>
        </div>
      )}
    </div>
  )
}
